import React, { useState } from "react";
import {  useNavigate } from "react-router-dom";
import SubmitButton from "../../common/button/SubmitButtton";
import useShowAlert from "../../../utiles/AlertUtiles";
import { removeWhitespace } from "../../../utiles/helpers";

const ResetPassword = ({ setLoggedIn }) => {

  const navigate = useNavigate();
  const showAlert = useShowAlert();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const Logo = process.env.REACT_APP_LOGO_URL;

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!password || !confirmPassword) {
      setError("Both fields are required.");
    } else if (password.length < 6 || confirmPassword.length < 6) {
      setError("Password must be at least 6 characters.");
    }  else if (password !== confirmPassword) {
      setError("Passwords do not match.");
    } else {
      setLoading(true);
      setTimeout(() => {
        showAlert("success", "Password reset successful!");
        setLoggedIn(true);
        navigate("/dashboard");
        showAlert("success", "Login successful!");
        setLoading(false);
      }, 1000);
    }
  };

  return (



    <div>
      <div className="wrapper">
        <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
          <div className="container">
            <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
             
              <div className="col mx-auto">
                <div className="card mb-0">
                  <div className="card-body ">
                    <div className="p-4">
                      <div className="text-center">
                        <img src={Logo} width="100" alt="" />
                      </div>
                      <h4 className="text-center mt-5 font-weight-bold">
                      Reset Password  🔒
                      </h4>
                      <p className="text-center text-muted">
                      We received your reset password request. Please enter your new password!
                      </p>
                      <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-12">
                          <label className="form-label  text-left">
                            New Password<span className="text-danger"> *</span>
                          </label>
                          <div className="input-group">
                            <input
                              type={passwordVisible ? "text" : "password"}
                              className="form-control"
                              value={password}
                              onChange={(e) => {
                                setPassword(removeWhitespace(e.target.value));
                                setError("");
                              }}
                            />
                            <span
                              className="input-group-text"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setPasswordVisible((prev) => !prev)
                              }
                            >
                              <i
                                className={
                                  passwordVisible ? "bx bx-show" : "bx bx-hide"
                                }
                              ></i>
                            </span>
                          </div>{" "}
                        </div>
                        <div className="col-12">
                          <label className="form-label  text-left">
                            Confirm Password
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-group">
                            <input
                              type={
                                confirmPasswordVisible ? "text" : "password"
                              }
                              className="form-control"
                              value={confirmPassword}
                              onChange={(e) => {
                                setConfirmPassword(removeWhitespace(e.target.value));
                                setError("");
                              }}
                            />
                            <span
                              className="input-group-text"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setConfirmPasswordVisible((prev) => !prev)
                              }
                            >
                              {" "}
                              <i
                                className={
                                  confirmPasswordVisible
                                    ? "bx bx-show"
                                    : "bx bx-hide"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                        {error && (
                          <small className="text-danger ">{error}</small>
                        )}
                        <SubmitButton
                          label="Set New Password"
                          loading={loading}
                        />
                          <div className="d-grid mt-3">
                                <a href="/login" className="btn btn-light">
                                  Back To Login
                                </a>
                              </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
